import React from "react";

import { Box, Textarea } from "@chakra-ui/react";
import { ReactComponent as InfoOutlineIcon } from "assets/icons/info-outline.svg";
import { useIndividualCompliance } from "contexts/individual-compliance-context";

import { Button } from "ui/button";
import { Modal } from "ui/modal";
import { ModalHeader } from "ui/modal/modal-header";
import { defaultModalCss } from "ui/modal/styles";
import { Heading3, Paragraph3 } from "ui/typography";

import { IRejectIndividualSectionModalProps } from "./types";

const MIN_REASON_LENGTH = 5;
export const RejectIndividualSectionModal = (
  props: IRejectIndividualSectionModalProps
) => {
  const {
    isOpen,
    setIsOpen,
    handleToggleRejectSectionModal,
    isLoading,
    handleRejectIndividualSection,
  } = props;

  const { rejectReason: reason, setRejectReason: setReason } =
    useIndividualCompliance();
  // const [reason, setReason] = useState("");

  const handleReasonChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { value } = evt.target;
    setReason(value);
  };

  const handleRejectSection = async () => {
    await handleRejectIndividualSection(reason);
  };

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      modalCss={{
        ...defaultModalCss,
        // height: "451px",
      }}
      allowOutsideClick={false}
    >
      <ModalHeader modalType="rejection" />
      <Box className="flex flex-col gap-5">
        <Box className="flex flex-col gap-2">
          <Heading3
            fontSize="18px"
            lineHeight="28px"
            textColor="#1A202C"
          >
            Reject This Section
          </Heading3>
          <Paragraph3
            lineHeight="20px"
            textColor="#475467"
          >
            Please confirm that you want to perform this action.
          </Paragraph3>
        </Box>
        <Box>
          <label className="text-[#101828] text-sm font-medium mb-[6px] block">
            Reason for rejection
          </label>
          <Textarea
            css={{
              border: "1px solid #D0D5DD",
              boxShadow: "box-shadow: 0px 1px 2px 0px #1018280D",
              borderRadius: "8px",
              height: "173px",
              padding: "10px 16px",
              fontSize: "14px",
              resize: "none",

              "&::placeholder": {
                color: "#B1B9CA",
              },
            }}
            placeholder="Enter your reason..."
            onChange={handleReasonChange}
            value={reason}
          />
        </Box>
        <Box
          css={{
            backgroundColor: "#FEF5E7",
            border: "1px solid #FFEFD8",
            height: "64px",
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "12px",
          }}
        >
          <Box
            css={{
              width: "16px",
              height: "16px",
              flexBasis: "16px",
              flexShrink: "0",
            }}
          >
            <InfoOutlineIcon className="w-full h-auto" />
          </Box>
          <Paragraph3
            lineHeight="20px"
            fontSize="13px"
            textColor="#1A202C"
          >
            This comment will be shared with the individual.
          </Paragraph3>
        </Box>
        <Box
          css={{
            height: "44px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Button
            variant="outline"
            textColor="#344054"
            border="1px solid #D0D5DD"
            className="w-[170px]"
            onClick={handleToggleRejectSectionModal}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant="solid"
            textColor="#ffffff"
            bgColor="#DC2626"
            border="1px solid #DC2626"
            className="w-[170px]"
            onClick={handleRejectSection}
            disabled={reason.length < MIN_REASON_LENGTH || isLoading}
            loading={isLoading}
            loadingText="Rejecting..."
          >
            Reject
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
